import React, { memo } from 'react';
import { THEME_OPTIONS as IN_APP_THEME_OPTIONS } from '../../inApp/helpers';

import { PreviewContainer } from '../PreviewContainer';

function InAppPreview({ variation, previewPage = false }) {
  return (
    <PreviewContainer
      themeOptions={IN_APP_THEME_OPTIONS}
      variation={variation}
      previewPage={previewPage}
      isShowMultiPlatform={false}
    />
  );
}

const Memoized = memo(InAppPreview);

export { Memoized as InAppPreview };
